import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { userReducer, tokenReducer, toastReducer, commesseFiltersReducer } from "../redux";
import { persistStore, persistReducer } from "redux-persist";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage/session";

const reducers = combineReducers({
  user: userReducer,
  token: tokenReducer,
  toast: toastReducer,
  commesseFilters: commesseFiltersReducer
});

const persistConfig = {
  timeout: 1,
  key: "campra",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
});
